import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
//import DriversComponent from "../DriversOld/DriversComponent";
import "./LoadsPOC.scss";
import Sidebar from "app/views/commonComponents/Sidebar/Sidebar";
import { Container } from "reactstrap";
import Breadcrumbs from "app/views/commonComponents/Breadcrumb/Breadcrumbs";
import Title from "app/views/commonComponents/Title/Title";
import DetailsHeader from "../../../../commonComponents/DetailsHeader/DetailsHeader";
import driverProfile from "../../../../../../assets/images/drivers/driverProfile.svg";
import accidents from "../../../../../../assets/images/drivers/accidents.svg";
import calendarRemove from "../../../../../../assets/images/drivers/calendarRemove.svg";
import moneys from "../../../../../../assets/images/drivers/moneys.svg";
import presentionChart from "../../../../../../assets/images/drivers/presentionChart.svg";
import star from "../../../../../../assets/images/drivers/star.svg";
import userTag from "../../../../../../assets/images/drivers/userTag.svg";
import TabButtons from "app/views/commonComponents/TabButtons/TabButtons";
import DriversTablePOC from "../../TablePOC/TablePOC";
//import DriversFilterButton from "../DriversFilterButton/DriversFilterButton";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import addIcon from "../../../../../../assets/images/poc/addIcon.svg";
import searchIcon from "../../../../../../assets/images/poc/searchIcon.svg";
import helloImage from "../../../../../../assets/images/poc/helloImage.png";
import CalenderChanger from "app/views/commonComponents/CalendarChanger/CalendarChanger";
import enterArrow from "../../../../../../assets/images/poc/enterArrow.svg";
import moment from "moment-timezone";
import grossRevenueGradient from "../../../../../../assets/images/poc/grossRevenueGradient.svg";
import grossMarginGradient from "../../../../../../assets/images/poc/grossMarginGradient.svg";
import rpmGradient from "../../../../../../assets/images/poc/rpmGradient.svg";
import driverPaymentsGradient from "../../../../../../assets/images/poc/driverPaymentsGradient.svg";
import milesLoadedGradient from "../../../../../../assets/images/poc/milesLoadedGradient.svg";
import loadsDeliveredGradient from "../../../../../../assets/images/poc/loadsDeliveredGradient.svg";
import {
  getAllLoadsData,
  getLoadsHeaderKPIData,
} from "app/apiServices/apiServices";
const LoadsPOC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeCalendarTab, setActiveCalendarTab] = useState(0);
  const [maxTableHeight, setMaxTableHeight] = useState(0);
  const [isDriversFilterOpen, setIsDriversFilterOpen] = useState(false);
  const [loadsOriginalData, setLoadsOriginalData] = useState([]);
  const [grossMargin, setGrossMargin] = useState(0);
  const [headerRPM, setHeaderRPM] = useState(0);
  const [milesLoaded, setMilesLoaded] = useState(0);
  const [loadsDelivered, setLoadsDelivered] = useState(0);
  const [revenue, setRevenue] = useState(0);
  const [avgRevenuePerLoad, setAvgRevenuePerLoad] = useState(0);
  const [loadsDetails, setLoadsDetails] = useState([]);
  const [clickedRowIndex, setClickedRowIndex] = useState();
  const [loadDetailsTableData, setLoadDetailsTableData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [firstNameUser, setFirstNameUser] = useState("");
  const [lastNameUser, setLastNameUser] = useState("");
  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Drivers", link: "/drivers" },
  ];
  const driverData = [
    //{ icon: userTag, values: "23,435", title: "On Fleet Drivers" },
    {
      icon: grossRevenueGradient,
      values: revenue ? `$${Math.round(revenue).toLocaleString("en-US")}` : 0,
      title: "Gross Revenue",
    },
    {
      icon: grossMarginGradient,
      values: grossMargin
        ? `$${Math.round(grossMargin).toLocaleString("en-US")}`
        : "$0.00",
      title: "Gross Margin",
    },
    {
      icon: loadsDeliveredGradient,
      values: loadsDelivered
        ? Math.round(loadsDelivered).toLocaleString("en-US")
        : 0,
      title: "Delivered Loads",
    },
    {
      icon: loadsDeliveredGradient,
      values: avgRevenuePerLoad
        ? `$${Math.round(avgRevenuePerLoad).toLocaleString("en-US")}`
        : "$0.00",
      title: "Avg. Revenue Per Load",
    },
    {
      icon: rpmGradient,
      values: headerRPM
        ? `$${headerRPM.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : "$0.00",
      title: "RPM",
    },
    {
      icon: milesLoadedGradient,
      values: milesLoaded ? Math.round(milesLoaded).toLocaleString("en-US") : 0,
      title: "Miles",
    },

    // { icon: moneys, values: "$3.54", title: "Avg. RPM" },
    // { icon: presentionChart, values: "86.3%", title: "Avg. RPM" },
    // Add more data items as needed
  ];
  const calendarTabsData = [
    { id: 0, label: "Month" },
    { id: 1, label: "Quarter" },
    { id: 2, label: "Year" },
    // Add more tabs as needed
  ];
  const loadsTableHeaders = {
    loadId: "Load No.",
    dates: "Dates",
    origin: "Origin",
    destination: "Destination",
    //driver: "Driver",
    vehicleId: "Vehicle Id.",
    //grossMargin: "Gross Margin",
    milesLoaded: "Loaded Miles",
    rpm: "RPM",
    revenue: "Revenue",
  };
  console.log("loadsOriginalDataGGG", loadsOriginalData);
  const loadsTableDataAPI = loadsOriginalData.map((load, index) => {
    const originalDateString = load.pu_date ? load.pu_date : "";
    let originalDate = moment.utc(originalDateString);
    const month = moment(originalDate).format("MMM");
    const day = moment(originalDate).date();
    const year = moment(originalDate).year();

    const originalDateString2 = load.del_date ? load.del_date : "";
    let originalDate2 = moment.utc(originalDateString2);
    const month2 = moment(originalDate2).format("MMM");
    const day2 = moment(originalDate2).date();
    const year2 = moment(originalDate2).year();

    let formattedDate = `${month} ${day}`;
    let formattedDate2 = `${month2} ${day2}`;
    let formattedDates = "";
    // Check if month1 is not equal to month2 and day1 is not equal to day2
    if (month !== month2 && day !== day2) {
      formattedDates = `${month} ${day} - ${month2} ${day2}, ${year}`;
    } else {
      // Check if both dates have the same month and day
      if (month === month2 && day === day2) {
        formattedDates = `${formattedDate}, ${year}`;
      } else {
        // Check if the years are different
        if (year !== year2) {
          formattedDates = `${formattedDate}, ${year}-${formattedDate2}, ${year2}`;
        } else {
          // Adjust the format based on different cases
          if (formattedDate === formattedDate2) {
            formattedDates = `${formattedDate}, ${year}`;
          } else if (day === day2) {
            formattedDates = `${formattedDate}${
              formattedDate2 ? `-${formattedDate2}` : ""
            }, ${year}`;
          } else if (month === month2) {
            formattedDates = `${month} ${day}-${day2}, ${year}`;
          }
        }
      }
    }

    // const formattedDates = `${formattedDate}${
    //   formattedDate2 ? `-${formattedDate2}` : ""
    // }, ${year}`;
    const truncatedOrigin =
      load.pu_location && load.pu_location.length > 20
        ? load.pu_location.substring(0, 20) + "..."
        : load.pu_location;
    const truncateddestination =
      load.del_location && load.del_location.length > 20
        ? load.del_location.substring(0, 20) + "..."
        : load.del_location;
    const loadIDWithCommas = parseInt(load.load_id).toLocaleString("en");
    return {
      loadId: load.load_id ? load.load_id : 0,
      dates: formattedDates,
      origin: truncatedOrigin,
      destination: truncateddestination,
      // driver: `${load.driver_1_full_name ? load.driver_1_full_name : ""} ${
      //   load.driver_2_full_name ? "-" : ""
      // } ${load.driver_2_full_name ?? load.driver_2_full_name}`, // You can replace this with the driver's name if available in your data
      vehicleId: load.vehicle_id ? load.vehicle_id : 0,
      // grossMargin: load.gross_margin
      //   ? `$${load.gross_margin.toLocaleString("en-US", {
      //       minimumFractionDigits: 2,
      //       maximumFractionDigits: 2,
      //     })}`
      //   : "$0.00",
      milesLoaded: load.loaded_miles ? load.loaded_miles.toLocaleString() : 0,
      rpm: load.rpm
        ? `$${load.rpm.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : "$0.00",
      revenue: load.load_revenue
        ? `$${load.load_revenue.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : 0,
    };
  });
  const loadDetailsTableHeaders = {
    loadID: enterArrow,
    payDescription: "Pay Description",
    revenue: "Revenue",
  };
  const loadSubTableData = loadsOriginalData.map((item) => item.load_details);
  // // Extract each array of objects
  for (let i = 0; i < loadSubTableData.length; i++) {
    console.log(`loadDetailsArray2 ${i}:`, loadSubTableData[i]);
  }
  console.log("loadsOriginalDataGGG2", loadDetailsTableData);
  const handleTabChange = (tabId) => {
    setActiveCalendarTab(tabId);
  };
  const handleRowClick = (rowIndex) => {
    console.log("ClickedrowIndex", rowIndex);
    setClickedRowIndex(rowIndex);
    const clickedRowData = loadSubTableData[rowIndex];
    setLoadDetailsTableData(clickedRowData);
  };

  const handleDateChange = (startDate, endDate) => {
    console.log("currentNewDate1", startDate);
    console.log("currentNewDate2", endDate);
    // Call getDetailsHeaderKPIDataAPI with final start and end dates
    getDetailsHeaderKPIData(startDate, endDate);
  };
  useEffect(() => {
    handleReturnLoadsPOC();
    const calculateMaxTableHeight = () => {
      // Get the window height
      const windowHeight = window.innerHeight;
      // Calculate the available height by subtracting the height of other elements if necessary
      const availableHeight =
        windowHeight - 325; /* subtract other elements height */
      // windowHeight - 240;
      // Set the max height of the table container
      setMaxTableHeight(availableHeight);
    };

    // Call the function initially and on window resize
    calculateMaxTableHeight();
    window.addEventListener("resize", calculateMaxTableHeight);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", calculateMaxTableHeight);
    };
  }, []);
  useEffect(() => {
    // Retrieve the data from localStorage
    const authUserData = localStorage.getItem("authUser");

    // Check if the data exists
    if (authUserData) {
      // Parse the JSON string back into a JavaScript object
      const userData = JSON.parse(authUserData);
      // setUserDetails(userData);
      // Now you can access the properties of the userData object
      console.log("userData", userData);
      console.log("userData2", userData.first_name);
      setFirstNameUser(userData.first_name);
      console.log("userData3", userData.last_name);
      setLastNameUser(userData.last_name);
    } else {
      // Handle the case where the data doesn't exist in localStorage
      console.log("No user data found in localStorage");
    }
    getAllLoadsDataAPI();
    if (
      activeCalendarTab == 0 ||
      activeCalendarTab == 1 ||
      activeCalendarTab == 2
    ) {
      getDetailsHeaderKPIData();
    }
  }, [activeCalendarTab]);
  const getAllLoadsDataAPI = () => {
    const storedToken = localStorage.getItem("token");
    // fetch(
    //   "https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/admin/loads/list",
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     if (result.status === 200) {
    //       return result.json();
    //     } else {
    //       alert("Please check login credentials!");
    //     }
    //   })
    getAllLoadsData()
      .then((response) => {
        //console.log("insideif", response);
        console.log("getAllLoadsData", response.data ? response.data : []);
        setLoadsOriginalData(response.data ? response.data : []);
        //let detailsArray = response.data
        //setLoadsDetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const getDetailsHeaderKPIData = (startDate, endDate) => {
    console.log("currentNewDate5", startDate);
    console.log("currentNewDate6", endDate);
    let currentStartDate = null;
    let currentEndDate = null;

    const currentDate = moment();
    const currentYear = currentDate.year();
    const currentMonth = currentDate.month() + 1; // Month index starts from 0

    switch (activeCalendarTab) {
      case 0: // Current month
        currentStartDate = moment().startOf("month").format("YYYY-MM-DD");
        currentEndDate = moment().endOf("month").format("YYYY-MM-DD");
        break;
      case 1: // Current quarter
        const currentQuarter = Math.floor((currentMonth - 1) / 3) + 1;
        const quarterStartMonth = (currentQuarter - 1) * 3;
        currentStartDate = moment().startOf("quarter").format("YYYY-MM-DD");
        currentEndDate = moment().endOf("quarter").format("YYYY-MM-DD");
        break;
      case 2: // Current year
        currentStartDate = moment().startOf("year").format("YYYY-MM-DD");
        currentEndDate = moment().endOf("year").format("YYYY-MM-DD");
        break;
      default:
        break;
    }
    console.log("currentNewDate3", currentStartDate);
    console.log("currentNewDate4", currentEndDate);
    // Use current dates if no startDate or endDate provided
    const finalStartDate = startDate || currentStartDate;
    const finalEndDate = endDate || currentEndDate;
    const storedToken = localStorage.getItem("token");
    // fetch(
    //   `https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/admin/loads/kpi?start_date=${startDate}&end_date=${endDate}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     if (result.status === 200) {
    //       return result.json();
    //     } else {
    //       alert("Please check login credentials!");
    //     }
    //   })
    getLoadsHeaderKPIData(finalStartDate, finalEndDate)
      .then((response) => {
        //console.log("insideif", response);
        console.log(
          "getDetailsHeaderKPIData",
          response.data ? response.data : ""
        );
        setGrossMargin(
          response.data.gross_margin ? response.data.gross_margin : ""
        );
        setHeaderRPM(response.data.rpm ? response.data.rpm : "");
        setMilesLoaded(
          response.data.miles_loaded ? response.data.miles_loaded : ""
        );
        setLoadsDelivered(
          response.data.loads_delivered ? response.data.loads_delivered : ""
        );
        setRevenue(response.data.revenue ? response.data.revenue : "");
        setAvgRevenuePerLoad(
          response.data.average_revenue_per_load
            ? response.data.average_revenue_per_load
            : ""
        );
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const [currentPageLoadsPOC, setCurrentPageLoadsPOC] = useState(1);
  const [itemsPerPageLoadsPOC, setItemsPerPageLoadsPOC] = useState(50);
  const handlePageChange = (pageNumber) => {
    setCurrentPageLoadsPOC(pageNumber);
  };
  const handleItemsPerPageChange = (perPage) => {
    setItemsPerPageLoadsPOC(perPage);
    setCurrentPageLoadsPOC(1); // Reset to the first page when changing items per page
  };
  const handleNavigateAway = () => {
    // Save current page and items per page
    // You can save these values to local storage or any other persistent storage
    localStorage.setItem("currentPageLoadsPOC", currentPageLoadsPOC);
    //localStorage.setItem("itemsPerPageLoadsPOC", itemsPerPageLoadsPOC);
  };
  const handleReturnLoadsPOC = () => {
    // Retrieve saved page and items per page
    const savedPage = localStorage.getItem("currentPageLoadsPOC");
    // const savedItemsPerPage = localStorage.getItem("itemsPerPageLoadsPOC");
    setCurrentPageLoadsPOC(savedPage ? parseInt(savedPage) : 1);
    // setItemsPerPageLoadsPOC(
    //   savedItemsPerPage ? parseInt(savedItemsPerPage) : 50
    // );
  };
  return (
    <React.Fragment>
      <div className="drivers-page">
        <Container fluid>
          <div className="">
            <Row
              xl={12}
              md={12}
              sm={12}
              xs={12}
              style={{ background: "#ffffff" }}
            >
              <Col xl={12} md={12} sm={12} xs={12}>
                {" "}
                <div className="stickyRowLoads">
                  <div className="headerLoads">
                    {/* <Breadcrumbs items={breadcrumbItems} /> */}
                    <div className="titleContainer">
                      <div className="greeting">High Roller Expediting</div>
                      <div style={{ marginTop: "8px", display: "flex" }}>
                        {/* <img
                          src={helloImage}
                          style={{
                            width: "34px",
                            height: "34px",
                            marginRight: "5px",
                          }}
                        /> */}
                        <Title
                          // name={`${firstNameUser} ${lastNameUser}`}
                          name={"Loads"}
                          type={"page"}
                        />
                      </div>
                    </div>
                    <div className="calenderChangeButtonContainerLoads">
                      <CalenderChanger
                        activeTab={activeCalendarTab}
                        onMonthChange={handleDateChange}
                        onQuarterChange={handleDateChange}
                        onYearChange={handleDateChange}
                      />
                    </div>
                    <div className="stickyTabButtonsLoads">
                      <TabButtons
                        tabs={calendarTabsData}
                        onTabChange={handleTabChange}
                      />
                    </div>
                  </div>
                  <div style={{ marginTop: "24px" }}>
                    <DetailsHeader data={driverData} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "24px",
                    }}
                    className="tableTitleContainerLoads"
                  >
                    {" "}
                    <div style={{ flex: "1" }}>
                      <Title
                        name={`Delivered Loads (${loadsTableDataAPI.length})`}
                        type={"table"}
                      />
                    </div>
                    {/* <div style={{ flex: "" }} className="searchBox">
                      <img src={searchIcon} />
                      <input
                        type="text"
                        placeholder="Search load no."
                        className="searchTextStyle"
                        style={{
                          border: "none",
                          background: "#fcfcfc",
                          padding: "0",
                        }}
                      />
                    </div> */}
                  </div>
                </div>
                <div className="tableContainerLoads">
                  {/* {loading ? (
                    <p> No Record Found</p>
                  ) : ( */}
                  <div
                    className="driversTableContainer"
                    style={{
                      maxHeight: `${maxTableHeight}px`,
                      padding: "0 16px 0 16px",
                      marginBottom: "16px",
                    }}
                  >
                    <div className="recentSettelmentsTableContainer">
                      <DriversTablePOC
                        headers={loadsTableHeaders}
                        data={loadsTableDataAPI}
                        activeTab={activeTab}
                        subHeaders={loadDetailsTableHeaders}
                        subData={loadDetailsTableData}
                        tableName={"loadsDetailsTable"}
                        rowClick={true}
                        rowClickHandler={handleRowClick}
                        paginationEnabled={true}
                        currentPage={currentPageLoadsPOC}
                        itemsPerPage={itemsPerPageLoadsPOC}
                        onPageChange={handlePageChange}
                        onItemsPerPageChange={handleItemsPerPageChange}
                        onNavigateAway={handleNavigateAway}
                      />
                    </div>
                  </div>
                  {/* )} */}
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default LoadsPOC;
